import { useTranslation } from 'react-i18next';

import { IconsFaces } from '@innovamat/glimmer-assets';
import { Typography } from '@innovamat/glimmer-components';

import {
  CourseTitle,
  TextWrapper,
  Wrapper,
} from '../../join-to-classroom.styled';

function SuccessJourneysStep(): JSX.Element {
  const { t } = useTranslation();

  return (
    <>
      <Wrapper>
        <IconsFaces />
        <TextWrapper>
          <Typography.H4>
            {t('classrooms.steps.success-journeys.subtitle')}
          </Typography.H4>
          <CourseTitle>
            {t('classrooms.steps.success-journeys.description')}
          </CourseTitle>
        </TextWrapper>
      </Wrapper>
    </>
  );
}

export { SuccessJourneysStep };
